import { useEffect } from "react";

import useTranslator from "@/shared/translate/translator";

import WalletView from "@/refund/views/wallet";

const Wallet: React.FC = () => {
  const { t } = useTranslator("refund.wallet");

  useEffect(() => {
    document.title = t("pageTitle");
  }, [t]);

  return <WalletView />;
};
export default Wallet;
